<ol class="breadcrumb">
    <breadcrumbs></breadcrumbs>
</ol>
<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <wj-tab-panel [selectedIndex]="0">
                <wj-tab>
                    <a>検索</a>
                    <div class="card">
                        <div class="card-header">
                            検索
                        </div>
                        <div class="card-body">
                            <div class="form-group row">
                                <label class="col-md-3 form-control-label d-none d-lg-block">日付</label>
                                <div class="col-md-3">
                                    <wj-input-date style="width:100%;" style="width:100%;" [(value)]="fromDate"
                                                   [format]="'yyyy/MM/dd'" [isRequired]="false"
                                                   [placeholder]="'から'"></wj-input-date>
                                </div>
                                <div class="col-md-3">
                                    <wj-input-date style="width:100%;" style="width:100%;" [(value)]="toDate"
                                                   [format]="'yyyy/MM/dd'" [isRequired]="false"
                                                   [placeholder]="'まで'"></wj-input-date>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-md-3 form-control-label d-none d-lg-block">検索</label>
                                <div class="col-md-3">
                                    <input type="text" [(ngModel)]="keyword" class="form-control" placeholder="検索">
                                </div>
                                <div class="col-md-3">
                                    <button (click)="search()" class="btn btn-primary btn-block">検索</button>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12">
                                    <wj-multi-row *ngIf="screenWidth >= 768" #measureGrid [isReadOnly]="true" [selectionMode]="'Row'"
                                                  style="height:500px" [itemsSource]="measures">
                                        <wj-multi-row-cell-group>
                                            <wj-multi-row-cell binding='id' [header]="'番号'" [width]="80">
                                            </wj-multi-row-cell>
                                        </wj-multi-row-cell-group>
                                        <wj-multi-row-cell-group>
                                            <wj-multi-row-cell binding='measureDate' [header]="'計量日'" [dataType]="'Date'" [format]="'yyyy/MM/dd'" [width]="100">
                                            </wj-multi-row-cell>
                                        </wj-multi-row-cell-group>
                                        <wj-multi-row-cell-group>
                                            <wj-multi-row-cell binding='department' [header]="'部門'" [width]="100">
                                            </wj-multi-row-cell>
                                        </wj-multi-row-cell-group>
                                        <wj-multi-row-cell-group>
                                            <wj-multi-row-cell binding='measureType' [header]="'対象'" [width]="100">
                                            </wj-multi-row-cell>
                                        </wj-multi-row-cell-group>
                                        <wj-multi-row-cell-group>
                                            <wj-multi-row-cell binding='cart' [header]="'カゴ車'" [width]="100">
                                            </wj-multi-row-cell>
                                        </wj-multi-row-cell-group>
                                        <wj-multi-row-cell-group>
                                            <wj-multi-row-cell binding='weight' [header]="'重量'" [dataType]="'Number'" [width]="80">
                                            </wj-multi-row-cell>
                                        </wj-multi-row-cell-group>
                                        <wj-multi-row-cell-group>
                                            <wj-multi-row-cell binding='memo' [header]="'メモ'" [width]="200">
                                            </wj-multi-row-cell>
                                        </wj-multi-row-cell-group>
                                    </wj-multi-row>
                                    <wj-multi-row *ngIf="screenWidth < 768" #measureGrid [isReadOnly]="true" [selectionMode]="'Row'"
                                                  style="height:500px" [itemsSource]="measures">
                                        <wj-multi-row-cell-group>
                                            <wj-multi-row-cell binding='id' [header]="'番号'" [width]="60">
                                            </wj-multi-row-cell>
                                        </wj-multi-row-cell-group>
                                        <wj-multi-row-cell-group [colspan]="2">
                                            <wj-multi-row-cell binding='department' [header]="'部門'" [width]="100">
                                            </wj-multi-row-cell>
                                            <wj-multi-row-cell binding='measureType' [header]="'対象'" [width]="100">
                                            </wj-multi-row-cell>
                                            <wj-multi-row-cell binding='measureDate' [header]="'計量日'" [dataType]="'Date'" [format]="'MM/dd'" [width]="100">
                                            </wj-multi-row-cell>
                                            <wj-multi-row-cell binding='cart' [header]="'カゴ車'" [width]="100">
                                            </wj-multi-row-cell>
                                            <wj-multi-row-cell binding='weight' [header]="'重量'" [dataType]="'Number'">
                                            </wj-multi-row-cell>
                                            <wj-multi-row-cell binding='memo' [header]="'メモ'">
                                            </wj-multi-row-cell>
                                        </wj-multi-row-cell-group>
                                    </wj-multi-row>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer">
                            <button (click)="export('measureGrid','計量情報')" class="btn btn-primary btn-block">エクスポート
                            </button>
                        </div>
                    </div>
                </wj-tab>
                <wj-tab>
                    <a>計量情報</a>
                    <div class="card">
                        <div class="card-header">
                            <div class="row">
                                <div class="col-md-2">
                                    <button (click)="mode = 'edit';createNew()" type="button"
                                            class="btn btn-block btn-primary">新規作成
                                    </button>
                                </div>
                                <div class="col-md-2">
                                    <button [disabled]="measure['@rid'] == '#-1:-1'" (click)="mode = 'edit'"
                                            type="button" class="btn btn-block btn-primary">編集
                                    </button>
                                </div>
                                <div class="col-md-2">
                                    <button [disabled]="measure['@rid'] == '#-1:-1'" (click)="confirmRemoveMeasure()"
                                            type="button" class="btn btn-block btn-danger">削除
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <fieldset [disabled]="mode == 'view'">
                                <div class="form-group row">
                                    <label class="col-md-3 form-control-label d-none d-lg-block">計量日</label>
                                    <div class="col-md-3">
                                        <wj-input-date style="width:100%;" style="width:100%;"
                                                       [(value)]="measure.measureDate" [format]="'yyyy/MM/dd'"
                                                       [isRequired]="false"
                                                       [placeholder]="'計量日'"></wj-input-date>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-md-3 form-control-label d-none d-lg-block">部門</label>
                                    <div class="col-md-9">
                                        <select class="form-control" [(ngModel)]="measure.department">
                                            <option *ngFor="let item of departments"
                                                    [value]="item.value">{{ item.value }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-md-3 form-control-label d-none d-lg-block">対象</label>
                                    <div class="col-md-9">
                                        <select class="form-control" [(ngModel)]="measure.measureType">
                                            <option *ngFor="let item of measureTypes"
                                                    [value]="item">{{ item }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-md-3 form-control-label d-none d-lg-block">カゴ車</label>
                                    <div class="col-md-9">
                                        <select class="form-control" [(ngModel)]="measure.cart">
                                            <option *ngFor="let item of carts"
                                                    [value]="item.value">{{ item.value }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-md-3 form-control-label d-none d-lg-block">重量</label>
                                    <div class="col-md-6">
                                        <input type="Number" [(ngModel)]="measure.weight" class="form-control"
                                               placeholder="重量">
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-md-3 form-control-label d-none d-lg-block">メモ</label>
                                    <div class="col-md-9">
                                        <textarea type="text" [(ngModel)]="measure.memo" class="form-control"
                                                  placeholder="メモ"></textarea>
                                    </div>
                                </div>
                            </fieldset>
                        </div>
                        <div class="card-footer">
                            <button *ngIf="mode == 'edit'" (click)="saveMeasure()"
                                    class="btn btn-primary btn-block">保存
                            </button>
                            <button *ngIf="mode == 'edit'" (click)="mode = 'view'; toTopMeasure();"
                                    class="btn btn-block btn-danger">キャンセル
                            </button>
                        </div>
                    </div>
                </wj-tab>
            </wj-tab-panel>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12">
            <div class="card">
                <div class="card-footer">
                    <div style="float:left; min-width: 150px;">
                        <wj-menu [(value)]="measures.pageSize" [header]="'ページサイズ'">
                            <wj-menu-item [value]="100">100</wj-menu-item>
                            <wj-menu-item [value]="500">500</wj-menu-item>
                            <wj-menu-item [value]="1000">1000</wj-menu-item>
                        </wj-menu>
                    </div>
                    <div style="float:left; min-width: 150px;">
                        <wj-collection-view-navigator [cv]="measures"></wj-collection-view-navigator>
                    </div>
                    <div style="float:left; min-width: 150px;">
                        <wj-collection-view-pager [cv]="measures"></wj-collection-view-pager>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<cb-modal-confirm #removeMeasurePopup (onConfirm)="removeMeasure()" [modalClass]="'modal-danger'"
                  [closeButton]="'キャンセル'" [confirmButton]="'削除'" [title]="'削除'"
                  [content]="'本当に' + measure.id + 'を削除しますか？'"></cb-modal-confirm>
